export default __webpack_public_path__ + "static/media/layer-critical-health.4c2d0e7e.svg";